import { modifier } from 'ember-modifier';
import { Calendar } from '@fullcalendar/core';
import interactionPlugin from '@fullcalendar/interaction';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';

export default modifier((element, positional, named) => {
  const {
    // Configuración básica
    initialView = 'dayGridMonth',
    events = [],
    headerToolbar = {
      left: 'prev,next today',
      center: 'title',
      right: 'dayGridMonth,timeGridWeek,timeGridDay'
    },
    height = 'auto',
    editable = true,
    selectable = true,
    selectMirror = true,
    dayMaxEvents = true,
    showWeekends = true,
    locale = 'es',

    // Callbacks
    onDateSelect,
    onEventClick,
    onEventDrop,
    onEventResize,
    onEventMount,
    onCalendarReady,
    onError,
    onLoading,

    // Cualquier otra opción personalizada
    ...customOptions
  } = named;

  const getEventColors = (type) => {
    const colorMap = {
      vacation: { bg: '#10b981', border: '#059669' },
      meeting: { bg: '#3b82f6', border: '#2563eb' },
      holiday: { bg: '#ef4444', border: '#dc2626' },
      training: { bg: '#8b5cf6', border: '#7c3aed' },
      sick_leave: { bg: '#f59e0b', border: '#d97706' },
      personal: { bg: '#6b7280', border: '#4b5563' },
    };
    return colorMap[type] || colorMap.personal;
  };

  // Event handlers
  const handleDateSelect = (selectInfo) => {
    onDateSelect?.(selectInfo);
  };

  const handleEventClick = (clickInfo) => {
    onEventClick?.(clickInfo.event);
  };

  const handleEventDrop = (dropInfo) => {
    onEventDrop?.(dropInfo);
  };

  const handleEventResize = (resizeInfo) => {
    onEventResize?.(resizeInfo);
  };

  const handleEventDidMount = (info) => {
    const type = info.event.extendedProps?.type;
    const colors = getEventColors(type);

    if (colors) {
      info.el.style.backgroundColor = colors.bg;
      info.el.style.borderColor = colors.border;
      info.el.style.color = colors.text || '#ffffff';
    }

    onEventMount?.(info);
  };

  const handleLoading = (isLoading) => {
    onLoading?.(isLoading);
  };

  // Configuración completa del calendario
  const calendarConfig = {
    // Plugins obligatorios
    plugins: [interactionPlugin, dayGridPlugin, timeGridPlugin],

    // Configuración base
    initialView,
    headerToolbar,
    height,
    editable,
    selectable,
    selectMirror,
    dayMaxEvents,
    weekends: showWeekends,
    locale,
    events,

    // Textos espanol
    buttonText: {
        today: 'Hoy',
        month: 'Mes',
        week: 'Semana',
        day: 'Día',
        list: 'Lista'
    },
    // Event handlers
    dateSelect: handleDateSelect,
    eventClick: handleEventClick,
    eventDrop: handleEventDrop,
    eventResize: handleEventResize,
    eventDidMount: handleEventDidMount,
    loading: handleLoading,

    ...customOptions
  };

  let calendar;

  try {
    calendar = new Calendar(element, calendarConfig);

    calendar.render();

    onCalendarReady?.(calendar);

  } catch (error) {
    console.error('Error initializing FullCalendar:', error);
    onError?.(error);
  }

  // Función de limpieza
  return () => {
    if (calendar) {
      try {
        calendar.destroy();
      } catch (error) {
        console.warn('Error destroying calendar:', error);
      }
    }
  };
});